import { useCallback, useState } from "react";
import { Form } from "react-bootstrap";

import { EditButtons } from "../../utils/components/EditButtons";
import { formatCurrency } from "../../utils/functions";

export const MaxBetrag = (props) => {
  const { value, label, shop, readOnly, showEditButtons, disabled, item, onChange } = props || {};

  const [edit, setEdit] = useState(false);
  const [maxBetrag, setMaxBetrag] = useState(Number(value));
  const [invalid, setInvalid] = useState(false);
  const [error, setError] = useState("");

  const onKeyPress = useCallback((e) => {
    if (!e || e.key !== "Enter") return;
    // do not send Form on RETURN
    e.preventDefault();
    e.currentTarget.blur();
    return false;
  }, []);

  const handleEdit = useCallback(() => {
    setEdit(true);
    if (typeof onChange === "function") onChange({ edit: true });
  }, [onChange]);

  const handleUndo = useCallback(() => {
    setMaxBetrag(value);
    setEdit(false);
    if (typeof onChange === "function") onChange({ edit: false });
  }, [onChange, value]);

  const handleCommit = useCallback(() => {
    if (Number(maxBetrag) < 0) return false;
    setEdit(false);
    setMaxBetrag(Number(maxBetrag));
    if (typeof onChange === "function") onChange({ value: Number(maxBetrag), item, shop });
  }, [item, maxBetrag, onChange, shop]);

  const onChangeValue = useCallback((e) => {
    if (!e || !e.target) return;
    const target = e.currentTarget || e.target;
    if (!target) return;
    const maxInputValue = 999999.99; // basketStorage.maxSum unterscheidet sich bei em und so
    const value = Number(target.value);
    if (value > maxInputValue) {
      setInvalid(true);
      setError(`Der Wert darf nicht größer als ${maxInputValue} sein.`);
    } else if (target.value === "" || value < 0) {
      setInvalid(true);
      setError(`Der Wert muß größer als 0 sein`);
    } else {
      setInvalid(false);
      setError("");
    }
    setMaxBetrag(target.value);
  }, []);

  const onBlur = useCallback((e) => {
    if (!e || !e.target) return;
    const target = e.currentTarget || e.target;
    if (!target) return;
    target.value = Number(maxBetrag);
  }, [maxBetrag]);

  if (isNaN(value)) return null;
  let editButtons = typeof showEditButtons === "boolean" ? showEditButtons : true;
  const dirty = false;
  if (readOnly) editButtons = false;

  return (
    <div className={(props.className || "") + " text-end"}>
      <Form.Group controlId={`maxBetrag-${shop}`} className="max-betrag input-group justify-content-end">
        {edit && !readOnly
          ? <>
            <Form.Label visuallyHidden="true">
              {label}
            </Form.Label>
            <Form.Control
              className={"text-end pt-0 pb-0"
                + (dirty ? " dirty mark" : "")
                + (invalid ? " is-invalid" : "")
              }
              value={maxBetrag}
              type="number"
              step="500"
              min="0"
              required
              onChange={onChangeValue}
              onBlur={onBlur}
              onKeyPress={onKeyPress}
            />
            <span className="input-group-text pt-0 pb-0">€</span>
          </>
          : <>
            <Form.Control
              disabled
              className={"text-end pt-0 pb-0 border-0 bg-transparent" + (dirty ? " dirty" : "")}
              type="text"
              value={formatCurrency(maxBetrag)}
            />
          </>
        }
      </Form.Group>
      {editButtons
        ? <EditButtons
          editMode={edit}
          disabled={disabled}
          handleEdit={handleEdit}
          handleUndo={handleUndo}
          handleCommit={handleCommit}
          invalid={invalid}
        />
        : null
      }
      {error
        ? <div className="alert alert-danger fs-6 p-1">{error}</div>
        : null
      }
    </div>
  );
};
export default MaxBetrag;
